import React from 'react';

export function NoConfigurationStageConfig() {
  return <p className="small">This stage has no additional configurable fields.</p>;
}
